import { JSX } from 'react'


import { HttpBody } from '@/lib/request.js'

import * as contract_storage from '@/storage/contract.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'




export default function
(
	props: {
		doc: HttpBody<contract_storage.TRawDocumentType>

		update(name: string, value: unknown): void

	},

)
:	JSX.Element
{
	let { insurance, enrollment } = props.doc

	let on_update = (name: string, value: unknown): void =>
	{
		props.update(name, value)

	}

	return (
		<Fieldset.Root divide name="保险信息">
			<Fieldset.Group>
				<Field.Text label="险种" name="insurance" value={insurance} change={on_update} />

				<Field.Date label="参保日期" name="enrollment" value={enrollment} change={on_update} />

			</Fieldset.Group>

		</Fieldset.Root>

	)

}
